import { Table } from "react-bootstrap";

type VariableSearchItemModalDataProps = {
  dataset: {
    value: number;
    label: string;
  };
  module: {
    value: number;
    label: string;
  };
  item: {
    label: string;
    description: string;
    answer_type_title: string;
    choice_text: string;
  };
};
export default function VariableSearchItemModal({ data }: { data: VariableSearchItemModalDataProps | null }) {
  return (
    <>
      <p className="g2-text-grey">
        <span className="fw-bold text-black">{data?.dataset.label}</span> &gt;{" "}
        <span className="fw-bold text-black">{data?.module.label}</span> <span className="g2-text-grey">&gt;</span>{" "}
        <span className="g2-text-grey">{data?.item.label}</span>
      </p>
      <Table className="table table-striped table-bordered" width="100%">
        <tbody>
          <tr>
            <td className="fw-bold" style={{ width: "25%" }}>
              Description:
            </td>
            <td>{data?.item.description}</td>
          </tr>
          <tr>
            <td className="fw-bold" style={{ width: "25%" }}>
              Answer type:
            </td>
            <td>{data?.item.answer_type_title}</td>
          </tr>
          <tr>
            <td className="fw-bold" style={{ width: "25%" }}>
              Answer choices:
            </td>
            <td>{data?.item.choice_text || "-"}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
}
